import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TSearchClearEventParams } from './_types';

export const searchClearEvent = (params: TSearchClearEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.SEARCH_CLEAR,
    params,
  });
};
